import React from "react";

/**
 * @component TaskAddIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 *
 * @example
 * return (
 *   <TaskAddIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const TaskAddIcon = React.forwardRef(
  (props: React.SVGProps<SVGSVGElement>, svgRef?: React.Ref<SVGSVGElement>) => (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="TaskAddIcon"
      fill="var(--color-theme-600)"
      focusable={false}
      ref={svgRef}
      {...props}
    >
      <path
        d="M12 2c5.523 0 10 4.477 10 10h-2a8 8 0 10-8 8v2C6.477 22 2 17.523 2 12S6.477 2 12 2zm7 12v3h3v2h-3v3h-2v-3.001L14 19v-2l3-.001V14h2zm-3.393-4.293a1 1 0 010 1.414l-3.657 3.657a1 1 0 01-1.414 0L8.707 12.95a1 1 0 011.414-1.414l1.12 1.12 2.951-2.949a1 1 0 011.415 0z"
        fillRule="evenodd"
      />
    </svg>
  )
);
TaskAddIcon.displayName = "TaskAddIcon";
export default TaskAddIcon;
